import {BrowserRouter, Route, Routes } from "react-router-dom";
import Homepage from "./Pages/Homepage";
import Navbar from "./Pages/Components/Navbar";
import { Analytics } from "@vercel/analytics/react"
import './App.css'
import ProjectPage from "./Pages/ProjectPage";
import Floaters from "./Pages/Components/Floaters";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route element = {<Homepage/>} path="/"/>
        </Routes>
        <Floaters/>
      </BrowserRouter>
      <Analytics/>
    </>
  );
};

export default App;
